var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vk-modal-body',[_c('services-modal-header',[_vm._v("\n    Submitting your request to Hand-Selected Local Professionals.\n  ")]),_c('services-modal-body',[_c('loading-indicator',{attrs:{"size":48}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }